import type { TDeviceType } from '@cian/ui-kit';
import { EQueryParameters } from '../repositories/feed-page/v2/mobile-site/get-recommendations/types';

import type {
  TLiquiditySourceSource,
  TLiquiditySourceDeviceType,
  TLiquiditySourceSuffix,
} from '../types/liquiditySource';

const landingTypeToLiquiditySourceSource: Record<EQueryParameters, TLiquiditySourceSuffix | ''> = {
  [EQueryParameters.MainPage]: 'recommendations_main',
  [EQueryParameters.FlatRent]: 'recommendations_main-rent',
  [EQueryParameters.SecondaryFlatSale]: 'recommendations_main-sale',
  [EQueryParameters.SuburbanSale]: '',
  [EQueryParameters.FlatRentForDay]: '',
};
export function mapLiquiditySource(
  landingType: EQueryParameters,
  deviceType: TDeviceType,
): TLiquiditySourceSource | '' {
  const suffix: TLiquiditySourceDeviceType = deviceType === 'desktop' ? 'web' : 'mobile-web';

  const liquiditySource = landingTypeToLiquiditySourceSource[landingType];

  if (!liquiditySource) {
    return '';
  }

  return `${suffix}_${liquiditySource}`;
}
